






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class SolidBtn extends Vue {}
